import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { OverlayPopover, Tabs } from '@utilities';
import buttonStyles from '@utilities/components/Button/_index.module.scss';
import SubscriptionOverview from '../../../SubscriptionOverview';
import Credits from './components/Credits';

import styles from './_index.module.scss';

const TABS = [
  { label: 'Completes', value: 'completes' },
  { label: 'Credits', value: 'credits' },
];

const VerifiedVoicesOverviewDropdown = ({
  hasSubscription,
  isVVOverviewDropdownActive,
  setActiveDropdown,
  target,
}) => {
  const [tab, setTab] = useState('completes');

  useEffect(() => {
    if (isVVOverviewDropdownActive) setTab('completes');
  }, [isVVOverviewDropdownActive]);

  return (
    <OverlayPopover
      className={styles['vv-overview-dropdown']}
      data-testid="vv-overview-dropdown"
      isActive={isVVOverviewDropdownActive}
      onHide={() => setActiveDropdown('')}
      target={target}
    >
      {hasSubscription ? (
        <>
          <div className={styles['vv-overview-tabs']}>
            <Tabs
              aria-label="Verified Voices summary type"
              onChange={setTab}
              options={TABS}
              value={tab}
            />
          </div>
          {tab === 'completes' ? <SubscriptionOverview /> : <Credits />}
        </>
      ) : (
        <Credits />
      )}
      <div className={styles['vv-overview-link']}>
        <Link
          onClick={() => setActiveDropdown('')}
          to={'/dashboard/verifiedvoices/instant-surveys'}
        >
          <div className={buttonStyles['button-tertiary']}>Create a Survey</div>
        </Link>
      </div>
    </OverlayPopover>
  );
};

VerifiedVoicesOverviewDropdown.propTypes = {
  hasSubscription: PropTypes.bool,
  isVVOverviewDropdownActive: PropTypes.bool,
  setActiveDropdown: PropTypes.func.isRequired,
  target: PropTypes.object,
};

export default VerifiedVoicesOverviewDropdown;
